import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "api/baseurl";
// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TextField from "@mui/material/TextField";

import {
  Box,
  Grid,
  Card,
  Typography,
  Tabs,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";

import { keyframes } from "@mui/system";
import { Button } from "@mui/material";
import AddHospitalDocuments from "./AddHospitalDocuments";
import Modal from "@mui/material/Modal";
import { toast } from "react-toastify";
import MDButton from "components/MDButton";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddPrescription from "./Addprescription";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";

function ViewHospitalProfile() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
   const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
const role =loginData?.role;
  const [coordinator, setCoordinator] = useState(null);
    const [prescription, setPrescription] = useState(null);
const [openDecisionModal, setOpenDecisionModal] = useState(false);
const [decisionType, setDecisionType] = useState("");
const [decisionMessage, setDecisionMessage] = useState("");
const [selectedUserId, setSelectedUserId] = useState(null);
  const [tab, setTab] = useState(0);
  const [selectedId, setSelectedId] = useState(null);
  const [opencertificateModal, setOpenCertificateModal] = useState(false);
    const [openprescriptionModal, setOpenPrescriptionModal] = useState(false);
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModal1, setDeleteModal1] = useState(false);

  const fetchCoordinator = async () => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      const response = await axios.get(`/api/hospitalprofile/hopsitalprofileid/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        setCoordinator(decrypted ||[]);
      }
    } catch (err) {
      console.error("Error fetching coordinator:", err);
    } finally {
      setLoading(false);
    }
  };
const doctors = coordinator?.doctor ? [coordinator.doctor] : [];

  useEffect(() => {
    fetchCoordinator();
    fetchprescription();
  }, [id]);

const fetchprescription = async (pageNumber = 1) => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      const response = await axios.get(`/api/prescriptiondetails/patientid/${id}`, {
        params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        setPrescription(decrypted.content || []);
         setCurrentPage(decrypted.number + 1);
          setTotalPages(decrypted.totalPages);
      }
    } catch (err) {
      console.error("Error fetching coordinator:", err);
    } finally {
      setLoading(false);
    }
  };
const handleDecision = async (userid, decision ,message) => {
  setLoading(true);

  try {
    const secretKey = await fetchSecretKey();
    const token = JSON.parse(localStorage.getItem("loginData"))?.token;

    const payload = {
      userid,
      decision,
       decisionMessage,
    };

    const encryptedData = encryptBody(payload, secretKey);

    const response = await axios.post(
      "/api/hospitalprofile/decision",
      encryptedData,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      const decryptedResponse = decryptBody(response.data, secretKey);

      if (!decryptedResponse) {
        throw new Error("Decryption failed or invalid response.");
      }

      toast.success(
        decision === "APPROVED"
          ? "Hospital approved successfully!"
          : "Hospital rejected successfully!"
      );
 
        fetchprescription();
setOpenDecisionModal(false);
  setDecisionMessage("");
  setDecisionType("");
  setSelectedUserId(null);
    }
  } catch (error) {
    console.error(error);

    toast.error(
      error.response?.data?.message ||
        error.message ||
        `Failed to ${decision.toLowerCase()} doctor.`
    );
  } finally {
    setLoading(false);
  }
};
   const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  if (loading) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          zIndex: 9999,
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 80,
            height: 80,
            animation: `${spinAnimation} 1.5s linear infinite`,
          }}
        >
          {dotPositions.map((pos, index) => (
            <Box
              key={index}
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                  backgroundColor:"#1A237E",
                position: "absolute",
                ...pos,
              }}
            />
          ))}
        </Box>
      </Box>
    );
  }

  const HandleCertificateModal = (id) => {
  setSelectedId(id);
  setOpenCertificateModal(true);
};
const handleClosecerrificateModal = () => {
  setOpenCertificateModal(false);
  setSelectedId(null);
};
  const HandleCertificateModal1 = (id) => {
  setSelectedId(id);
  setOpenPrescriptionModal(true);
};
const handleClosecerrificateModal1 = () => {
  setOpenPrescriptionModal(false);
  setSelectedId(null);
  fetchprescription();
  
};

 const handleOpenDeleteModal = (id) => {
      setSelectedId(id);
      setDeleteModal(true);
    };

const handleDelete = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        const encryptedData = encryptBody({ id: selectedId }, secretKey);
    
        const response = await axios.post("/api/hospitalprofiledocuments/delete", encryptedData, {
          headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
        });
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success(decryptedResponse.message || "Patient Documents deleted successfully!");
    
          setDeleteModal(false); 
          fetchCoordinator();
        }
      } catch (error) {
        toast.error(error.message || "Failed to delete Doctor Documents.");
      } finally {
        setLoading(false);
      }
    };

     const handleOpenDeleteModal1 = (id) => {
      setSelectedId(id);
      setDeleteModal1(true);
    };

const handleDelete1 = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        const encryptedData = encryptBody({ id: selectedId }, secretKey);
    
        const response = await axios.post("/api/prescriptiondetails/delete", encryptedData, {
          headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
        });
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success(decryptedResponse.message || "Prescription deleted successfully!");
    
          setDeleteModal1(false); 
          fetchprescription();
        }
      } catch (error) {
        toast.error(error.message || "Failed to delete Prescription.");
      } finally {
        setLoading(false);
      }
    };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MedicalAbstractBackground/>
    <Card sx={{ p: 3, mt: 3 }}>
  {coordinator ? (
    <Grid container spacing={3}>
      {/* Left: Profile Image */}
      <Grid item xs={12} md={4} textAlign="left" sx={{ ml: "24px" }}>
       <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
          <strong>Hospital Name:</strong> {coordinator.hospitalName}
        </Typography>
{/* <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>NMC Registered Number:</strong> {coordinator.nmcRegisteredNumber}
        </Typography><Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>year Of Registration:</strong> {coordinator.yearOfRegistration}
        </Typography><Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>verification Status:</strong> {coordinator.verificationstatus}
        </Typography> */}
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Hospital ID:</strong> {coordinator.hospitalId}
        </Typography>
       <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Hospital Code:</strong> {coordinator.hospitalCode}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Director Name:</strong> {coordinator.directorName}
        </Typography>
      <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
  <strong>Address:</strong>{" "}
  {[coordinator.addressLine1, coordinator.city, coordinator.state, coordinator.country]
    .filter(Boolean)
    .join(", ")}
  {coordinator.pincode ? ` - ${coordinator.pincode}` : ""}
</Typography>

          <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Address 2:</strong> {coordinator.addressLine2}
        </Typography>
      </Grid>

      {/* Middle: Basic Info */}
      <Grid item xs={12} md={4}  sx={{ mt: 4.2 }}>
         <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Phone Number:</strong> {coordinator.phonecountrycode} {coordinator.phoneNumber}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Emergency Number:</strong> {coordinator.emergencycountrycode} {coordinator.emergencyphoneNumber}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Email:</strong> {coordinator.email}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Website:</strong> {coordinator.website}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>GST No:</strong> {coordinator.gstno}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>MCA CIN:</strong> {coordinator.mcaCin}
        </Typography>
      </Grid>

      {/* Right: More Info */}
      <Grid item xs={12} md={4} sx={{ ml: "-24px",mt: 4.2 }}  >
          
         <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Registration Authority:</strong> {coordinator.registrationAuthority}
        </Typography>
         <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Registration Number:</strong> {coordinator.registrationNumber}
        </Typography>
          <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Ownership type:</strong> {coordinator.ownershipType}
        </Typography>
         <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Hospital Type:</strong> {coordinator.hospitalType}
        </Typography>
         <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Establishment Year:</strong> {coordinator.establishmentYear}
        </Typography>
         
       
      </Grid>
    </Grid>
  ) : (
    <Typography
      sx={{
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "16px",
        color: "gray",
        my: 2,
      }}
    >
      No Data Available
    </Typography>
  )}

        {/* Tabs Section */}
        <Box sx={{ mt: 4 }}>
        <Tabs
  value={tab}
  onChange={(e, newVal) => setTab(newVal)}
  variant="scrollable"
  scrollButtons="auto"
  TabIndicatorProps={{
    style: {
      backgroundColor: "#1A237E", // elegant blue underline
      height: "3px",
      borderRadius: "2px",
    },
  }}
  sx={{
    backgroundColor: "#fff", // clean white bg
    borderBottom: "1px solid #e0e0e0",
    "& .MuiTab-root": {
      fontWeight: 500,
      fontSize: "16px",
      textTransform: "none",
      color: "#666",
      minHeight: "48px",
      padding: "10px 20px",
      transition: "all 0.3s ease",
    },
    "& .Mui-selected": {
      color: "#1A237E", // professional blue
      fontWeight: 600,
    },
    "& .MuiTab-root:hover": {
      color: "#1A237E",
      backgroundColor: "rgba(25, 118, 210, 0.08)", // light hover
      borderRadius: "6px 6px 0 0",
    },
  }}
>


  <Tab  label="Demographic Certificate" />
  
</Tabs>






       {tab === 0 && (
  <Box sx={{ mt: 2 }}>
    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
      <Button
        variant="outlined"
       sx={{
                         textTransform: "none",
                         color: "#1A237E",
                         borderColor: "#1A237E",
                         backgroundColor: "transparent",
                         height: 40,
                           mt: 1,
                         "&:hover": {
                           backgroundColor: "#f0f0f0",
                           borderColor: "#1A237E",
                         },
                         "&:focus": {
                           outline: "none",
                         },
                       }}
        onClick={() => HandleCertificateModal(coordinator?.id)}
      >
        + Add Documents
      </Button>
    </Box>
    <Table sx={{ border: "1px solid #ddd" }}>
      <TableHead>
        <TableRow sx={{ backgroundColor:"#1A237E" }}>
          {["Document Name", "Date of Upload", "Action"].map((header, index) => (
            <TableCell
              key={index}
              sx={{
                 color: "#fff",
                fontWeight: "600", 
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "12px",
  minWidth: index === 0 ? "315px" : "195px",
width: index === 0 ? "315px" : "400px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
   <TableBody>
  {coordinator?.documents?.length > 0 ? (
    coordinator.documents.map((doc, idx) => (
      <TableRow key={idx}>
        <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {doc.documentname}
        </TableCell>
        {/* <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {doc.documenttype}
        </TableCell> */}
        <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {doc.dateofupload}
        </TableCell>
        <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          <IconButton
            color="default"
            onClick={(event) => {
              event.stopPropagation();
              handleOpenDeleteModal(doc.id);
            }}
          >
            <DeleteIcon />
          </IconButton>

         {doc.image ? (
  <Tooltip title="View Document">
   <IconButton
    sx={{
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.05)",
      },
    }}
    onClick={() => {
      // Validate document data
      if (!doc?.image) {
        alert('No document data available to preview');
        return;
      }

      try {
        // Detect file type from base64 signature since documenttype is null
        const base64Start = doc.image.substring(0, 50);
        
        // PDF starts with "JVBERi0x" (base64 of "%PDF")
        const isPDF = base64Start.startsWith('JVBERi0x') || 
                      doc.documenttype === "application/pdf" || 
                      doc.documenttype === "pdf" ||
                      doc.documentname?.toLowerCase().endsWith('.pdf');
        
        // PNG starts with "iVBORw0KGgo"
        const isPNG = base64Start.startsWith('iVBORw0KGgo');
        
        // JPEG starts with "/9j/"
        const isJPEG = base64Start.startsWith('/9j/');
        
        console.log('Detected types - PDF:', isPDF, 'PNG:', isPNG, 'JPEG:', isJPEG);

        if (isPDF) {
          // PDF handling with blob
          const binaryString = atob(doc.image);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          const blob = new Blob([bytes], { type: 'application/pdf' });
          console.log('PDF Blob size:', blob.size, 'bytes');
          
          const fileURL = URL.createObjectURL(blob);
          const pdfWindow = window.open(fileURL, '_blank');
          
          if (!pdfWindow) {
            alert('Popups are blocked. Please enable popups for this site.');
          }
          
          setTimeout(() => URL.revokeObjectURL(fileURL), 120000);
        } else {
          // Image handling - auto-detect MIME type
          let mimeType;
          if (isPNG) {
            mimeType = 'image/png';
          } else if (isJPEG) {
            mimeType = 'image/jpeg';
          } else {
            // Default to png if unknown
            mimeType = 'image/png';
          }
          
          console.log('Using MIME type:', mimeType);
          
          const fileURL = `data:${mimeType};base64,${doc.image}`;
          
          const newWindow = window.open('', '_blank');
          if (newWindow) {
            newWindow.document.write(`
              <!DOCTYPE html>
              <html>
                <head>
                  <title>Image Preview - ${doc.documentname || 'Document'}</title>
                  <style>
                    body { 
                      margin: 0; 
                      display: flex; 
                      justify-content: center; 
                      align-items: center; 
                      min-height: 100vh; 
                      background: #2c3e50;
                    }
                    img { 
                      max-width: 95%; 
                      max-height: 95vh; 
                      box-shadow: 0 4px 20px rgba(0,0,0,0.5);
                      border-radius: 4px;
                    }
                    .error {
                      color: white;
                      text-align: center;
                      font-family: Arial, sans-serif;
                      padding: 20px;
                    }
                  </style>
                </head>
                <body>
                  <img 
                    src="${fileURL}" 
                    alt="${doc.documentname || 'Document'}"
                    onload="console.log('Image loaded successfully')"
                    onerror="this.style.display='none'; document.body.innerHTML='<div class=error><h2>Failed to load image</h2><p>Please try downloading the file instead.</p></div>'"
                  />
                </body>
              </html>
            `);
            newWindow.document.close();
            newWindow.focus();
          } else {
            alert('Popups are blocked. Please enable popups for this site.');
          }
        }
      } catch (error) {
        console.error('Error opening document:', error);
        alert('Error opening document: ' + error.message);
      }
    }}
  >
    <VisibilityIcon />
  </IconButton>
  </Tooltip>
) : (
  "—"
)}
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell
        colSpan={4}
        align="center"
        sx={{ border: "1px solid #ddd", color: "gray", fontStyle: "italic" }}
      >
        No Data Available
      </TableCell>
    </TableRow>
  )}
</TableBody>

                  </TableHead>

    </Table>
  </Box>
)}



        </Box>
      </Card>
        {/* Review Action Buttons */}
        {role !== "ROLE_CARE_COORDINATOR" && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              mt: 4,
              pt: 3,
              borderTop: "1px solid #e0e0e0",
            }}
          >
            {coordinator?.decision === "APPROVED" ? (
          <Button
            variant="contained"
            disabled
            sx={{
              minWidth: 120,
              textTransform: "none",
              borderRadius: "8px",
              fontWeight: 600,
              backgroundColor: "#2E7D32",
              color: "#fff",
              "&.Mui-disabled": {
                backgroundColor: "#2E7D32",
                color: "#fff",
                opacity: 1,
              },
            }}
          >
            Approved
          </Button>
        ) : coordinator?.decision === "REJECTED" ? (
          <Button
            variant="contained"
            disabled
            sx={{
              minWidth: 120,
              textTransform: "none",
              borderRadius: "8px",
              fontWeight: 600,
              backgroundColor: "#D32F2F",
              color: "#fff",
              "&.Mui-disabled": {
                backgroundColor: "#D32F2F",
                color: "#fff",
                opacity: 1,
              },
            }}
          >
            Rejected
          </Button>
        ) : (
          <>
            {/* Approve Button */}
            <Button
              variant="contained"
              onClick={() => {
                setSelectedUserId(coordinator.userid);
                setDecisionType("APPROVED");
                setDecisionMessage("");
                setOpenDecisionModal(true);
              }}
              sx={{
                backgroundColor: "#2E7D32",
                color: "#fff",
                textTransform: "none",
                borderRadius: "8px",
                minWidth: 120,
                "&:hover": {
              backgroundColor: "#1B5E20",
            },
            "&:focus": {
              backgroundColor: "#2E7D32",
            },
            "&:focus-visible": {
              backgroundColor: "#2E7D32",
              outline: "none",
            },
          }}
            >
              Approve
            </Button>
        
            {/* Reject Button */}
            <Button
              variant="contained"
              onClick={() => {
                setSelectedUserId(coordinator.userid);
                setDecisionType("REJECTED");
                setDecisionMessage("");
                setOpenDecisionModal(true);
              }}
              sx={{
                backgroundColor: "#D32F2F",
                color: "#fff",
                textTransform: "none",
                borderRadius: "8px",
                minWidth: 120,
                "&:hover": {
                  backgroundColor: "#B71C1C",
                },
              }}
            >
              Reject
            </Button>
          </>
        )}
          </Box>
        )}
        <Modal
          open={openDecisionModal}
          onClose={() => setOpenDecisionModal(false)}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card
            sx={{
              width: 450,
              p: 3,
              borderRadius: 3,
            }}
          >
            <Typography
              variant="h6"
              sx={{ mb: 2, fontWeight: "bold", textAlign: "center" }}
            >
              {decisionType === "APPROVED"
                ? "Approve Doctor"
                : "Reject Doctor"}
            </Typography>
        
            <Typography   sx={{
            mb: 2,
            fontSize: "14px", 
            color: "text.secondary",
          }}>
              {decisionType === "APPROVED"
                ? "Please enter an approval message."
                : "Please enter the reason for rejection."}
            </Typography>
        
            <TextField
              fullWidth
              multiline
              rows={4}
              label={
                decisionType === "APPROVED"
                  ? "Approval Message"
                  : "Rejection Reason"
              }
              value={decisionMessage}
              onChange={(e) => setDecisionMessage(e.target.value)}
            />
        
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                  sx={{
            backgroundColor: "#757575",
            color: "#fff",
            textTransform: "none",
            borderRadius: "8px",
            minWidth: 120,
            fontWeight: 600,
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#757575",
              boxShadow: "none",
            },  }}
                onClick={() => {
                  setOpenDecisionModal(false);
                  setDecisionMessage("");
                }}
              >
                Cancel
              </Button>
        
              <Button
                variant="contained"
                color={decisionType === "APPROVED" ? "success" : "error"}
                disabled={!decisionMessage.trim()}
                  sx={{
            backgroundColor:
              decisionType === "APPROVED" ? "#4CAF50" : "#F44336",
            color: "#fff",
            textTransform: "none",
            borderRadius: "8px",
            minWidth: "120px",
            "&:hover": {
              backgroundColor:
                decisionType === "APPROVED" ? "#388E3C" : "#D32F2F",
            },
            "&.Mui-disabled": {
              backgroundColor: "#BDBDBD",
              color: "#fff",
            },
          }}
                onClick={() =>
                  handleDecision(
                    selectedUserId,
                    decisionType,
                    decisionMessage
                  )
                  
                }
                
              >
                {decisionType === "APPROVED" ? "Approve" : "Reject"}
              </Button>
            </Box>
          </Card>
        </Modal>
      <Modal open={deleteModal} onClose={() => setDeleteModal(false)} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Card sx={{ padding: 3, width: "400px", textAlign: "center" }}>
                      <Typography variant="h6" gutterBottom>Are you sure you want to delete this Document</Typography>
                      <MDButton onClick={handleDelete} color="error"  sx={{ minWidth: "60px", marginRight: "5px", padding: "5px 10px" }}>Yes</MDButton>&emsp;
                      <MDButton color="secondary" onClick={() => setDeleteModal(false)} sx={{ minWidth: "30px" }}>Cancel</MDButton>
                    </Card>
                  </Modal>
                   

      {opencertificateModal && (
  <AddHospitalDocuments
    isOpen={opencertificateModal}
    onRequestClose={handleClosecerrificateModal}
    id={selectedId}
    fetchCoordinator = {fetchCoordinator}
  />
)}
{openprescriptionModal && (
  <AddPrescription
    isOpen={openprescriptionModal}
    onRequestClose={handleClosecerrificateModal1}
    id={selectedId}
  />
)}
    </DashboardLayout>
  );
}

export default ViewHospitalProfile;
